import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pause\"><path d=\"M10.313 17.625H9.187V6.375h1.126v11.25Zm4.5 0h-1.126V6.375h1.126v11.25Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol